import React, { useState } from 'react';
import api from '../services/api';

export default function DataDeletionRequest() {
  const [email,   setEmail]   = useState('');
  const [reason,  setReason]  = useState('');
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');
  const [success, setSuccess] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/data-deletion', { email, reason });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh', background: '#f4f6f3',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '32px 16px', fontFamily: 'system-ui, sans-serif',
    }}>
      <div style={{ width: '100%', maxWidth: 480 }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            width: 56, height: 56, borderRadius: 14, background: '#2d6a4f',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 16px', fontSize: 24,
          }}>
            🗑️
          </div>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: '#1a1a1a', margin: '0 0 6px' }}>
            Account & Data Deletion Request
          </h1>
          <p style={{ fontSize: 14, color: '#666', margin: 0, lineHeight: 1.6 }}>
            Submit your email address below and we will delete your account and all associated data within 30 days.
          </p>
        </div>

        {success ? (
          /* Success state */
          <div style={{
            background: '#fff', borderRadius: 14, padding: 32, textAlign: 'center',
            boxShadow: '0 2px 16px #0000000d',
          }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <h2 style={{ fontSize: 18, fontWeight: 700, color: '#2d6a4f', margin: '0 0 10px' }}>
              Request Received
            </h2>
            <p style={{ fontSize: 14, color: '#555', lineHeight: 1.7, margin: 0 }}>
              Your deletion request has been submitted successfully.
              We will process it within <strong>30 days</strong> and send a confirmation to <strong>{email}</strong>.
            </p>
          </div>
        ) : (
          /* Form */
          <div style={{
            background: '#fff', borderRadius: 14, padding: 32,
            boxShadow: '0 2px 16px #0000000d',
          }}>
            <form onSubmit={handleSubmit}>

              {error && (
                <div style={{
                  background: '#fff1f1', border: '1px solid #fca5a5',
                  borderRadius: 8, padding: '10px 14px',
                  color: '#dc2626', fontSize: 13, marginBottom: 20,
                }}>
                  {error}
                </div>
              )}

              <div style={{ marginBottom: 18 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#444', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.05em' }}>
                  Email Address *
                </label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="Enter the email linked to your account"
                  style={{
                    width: '100%', padding: '10px 12px', fontSize: 14,
                    border: '1px solid #ddd', borderRadius: 8, outline: 'none',
                    boxSizing: 'border-box', transition: 'border .15s',
                  }}
                  onFocus={e => e.target.style.borderColor = '#2d6a4f'}
                  onBlur={e => e.target.style.borderColor = '#ddd'}
                />
              </div>

              <div style={{ marginBottom: 24 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#444', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.05em' }}>
                  Reason (optional)
                </label>
                <textarea
                  value={reason}
                  onChange={e => setReason(e.target.value)}
                  placeholder="Let us know why you want to delete your account..."
                  rows={3}
                  style={{
                    width: '100%', padding: '10px 12px', fontSize: 14,
                    border: '1px solid #ddd', borderRadius: 8, outline: 'none',
                    boxSizing: 'border-box', resize: 'vertical', transition: 'border .15s',
                    fontFamily: 'inherit',
                  }}
                  onFocus={e => e.target.style.borderColor = '#2d6a4f'}
                  onBlur={e => e.target.style.borderColor = '#ddd'}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%', padding: '12px', fontSize: 14, fontWeight: 600,
                  background: loading ? '#aaa' : '#2d6a4f', color: '#fff',
                  border: 'none', borderRadius: 8, cursor: loading ? 'not-allowed' : 'pointer',
                  transition: 'background .15s',
                }}
              >
                {loading ? 'Submitting…' : 'Submit Deletion Request'}
              </button>

            </form>

            {/* Info note */}
            <div style={{
              marginTop: 20, padding: '12px 14px',
              background: '#f8faf8', borderRadius: 8, fontSize: 12, color: '#666', lineHeight: 1.6,
            }}>
              <strong>What gets deleted:</strong> Your account, profile information, activity history, and all personal data associated with your account. This action cannot be undone.
            </div>
          </div>
        )}

        <p style={{ textAlign: 'center', fontSize: 12, color: '#999', marginTop: 24 }}>
          Sulthaniya Foundation · For questions contact us at{' '}
          <a href="mailto:support@sulthaniya.in" style={{ color: '#2d6a4f' }}>support@sulthaniya.in</a>
        </p>

      </div>
    </div>
  );
}
